import React from "react";
import get from "lodash/get";
import dayjs from "dayjs";
import styled from "styled-components";
import SaveIcon from "@mui/icons-material/Save";
import LaunchIcon from "@mui/icons-material/Launch";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import { DOCUMENT_TYPES } from "../../helpers/constants";
import DocumentDraftService from "../../services/DocumentDraftService";

const DraftItem = ({ draft, refetch }) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const {
    id,
    documentTypeId,
    startDate,
    endDate,
    createdAt,
    updatedAt,
    estateId,
    owner,
  } = draft;

  const docType = DOCUMENT_TYPES.find((doc) => doc.id === documentTypeId);
  const startDateObj = dayjs(startDate);
  const endDateObj = dayjs(endDate);
  const dateStr =
    startDateObj.month() === endDateObj.month()
      ? startDateObj.format("MM/YYYY")
      : `${startDateObj.format("DD/MM/YYYY")} au ${endDateObj.format(
          "DD/MM/YYYY"
        )}`;

  const createdAtStr = !!createdAt
    ? dayjs(createdAt).format("DD/MM/YYYY HH:mm")
    : "-";
  const updatedAtStr = !!updatedAt
    ? dayjs(updatedAt).format("DD/MM/YYYY HH:mm")
    : "-";

  const removeDraft = async () => {
    try {
      const res = await DocumentDraftService.remove(id);
      if (res.success) {
        enqueueSnackbar("Brouillon supprimé avec succès", {
          variant: "success",
          anchorOrigin: {
            horizontal: "right",
            vertical: "top",
          },
        });
        !!refetch && refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openDraft = async () => {
    const baseUrl = `/new-document/${estateId}`;
    const searchParams = new URLSearchParams({
      documentType: documentTypeId,
      owner,
      startDate: dayjs(startDate).format("DD/MM/YYYY"),
      endDate: dayjs(endDate).format("DD/MM/YYYY"),
      draft: id,
    });
    const url = `${baseUrl}?${searchParams.toString()}`;
    navigate(url);
  };

  return (
    <StyleWrapper className="drafts-list__item shadow-sm rounded-box d-flex justify-content-between align-items-center">
      <Stack
        flexDirection="row"
        alignItems="center"
        className="draft-header"
        flexShrink={0}
        maxWidth="100%"
      >
        <SaveIcon htmlColor="var(--red-color)" />
        <Typography component="span" textAlign="center" fontWeight="600">
          {get(docType, "name", "-")} à la période du {dateStr}
        </Typography>
      </Stack>
      <Stack flexDirection="row" alignItems="center" gap={2}>
        <Stack>
          <Typography component="span" fontSize={14} fontWeight={300}>Création: {createdAtStr}</Typography>
          <Typography component="span" fontSize={14} fontWeight={300}>
            Dernière modification: {updatedAtStr}
          </Typography>
        </Stack>
        <Stack flexDirection="row" alignItems="center">
          <IconButton color="primary" variant="contained" onClick={openDraft}>
            <LaunchIcon htmlColor="var(--light-grey-text)" />
          </IconButton>
          <IconButton onClick={removeDraft}>
            <DeleteIcon htmlColor="var(--red-color)" />
          </IconButton>
        </Stack>
      </Stack>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.drafts-list__item {
    padding: 0 15px;
    min-height: 73px;
    gap: 20px;
    border-radius: 6px;
  }

  .draft-header {
    span {
      margin-left: 12px;
      font-size: 18px;
      font-weight: 700;
    }
  }
`;

export default DraftItem;
